"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_MRD_PERMISSIONS = exports.MrdPermissions = void 0;
/**
 * MRD (MEDICAL RECORDS DEPARTMENT) MODULE permissions.
 *
 * MRD is the desk that receives a finished stay's file, checks it is complete, codes it, keeps the statutory registers
 * (birth, death, medico-legal) and lends the physical file out and takes it back. It READS the stay the ward and the discharge
 * desk already produced; it never changes who may END a stay (that stays on the `ip:*` keys).
 *
 * Six keys, each its own because each is a different act by a different person:
 *
 *   mrd:desk:view          open the MRD pages and READ everything in them: the inbox, the registers, the coding of a stay, the
 *                          statistics. A hospital manager or the NABH coordinator holds this and nothing else.
 *   mrd:file:manage        take a discharged file in (the "received" stamp), raise and close a deficiency against the doctor,
 *                          issue a physical file to a ward / doctor / insurer and take it back. The records clerk's key.
 *   mrd:coding:manage      assign, change and FINALISE the diagnosis and procedure codes of a stay, and maintain the code master.
 *                          The coder's key. Kept apart from the clerk's: a clerk who files must not also rewrite a diagnosis.
 *   mrd:register:manage    write the birth, death and medico-legal registers. Registers are statutory records; the people who
 *                          may read them (desk:view) are not thereby the people who may enter them.
 *   mrd:certificate:issue  print a birth, death or medical certificate, and RELEASE a copy of a record to a requester. Its own key because
 *                          a certificate or a copy LEAVES the building with the hospital's name on it; every one is written to the
 *                          audit trail and to the issue log, like the lab's batch print.
 *   mrd:retention:manage   set the retention periods, and propose, approve and record the DESTRUCTION of records. Its own key because
 *                          destruction cannot be undone: the person who proposes a batch may never be the person who approves it.
 *
 * Kept to SIX on purpose: every permission is embedded in every JWT, and that has already hit Node's and nginx's header limits
 * twice. Every key is a strict 3-segment `mrd:resource:action`.
 *
 * Adding this family takes TWO edits, not one — `PermissionService.seedMrdCatalog()` and its name in
 * `scripts/deploy-seed-all-catalogs.ts`; without the second every `/v1/mrd` route answers 403 to everyone, SuperAdmin included
 * (the BUG-0006 shape). `mrd-permission-catalog.test.ts` asserts both.
 */
exports.MrdPermissions = {
    MRD_DESK_VIEW: 'mrd:desk:view',
    MRD_FILE_MANAGE: 'mrd:file:manage',
    MRD_CODING_MANAGE: 'mrd:coding:manage',
    MRD_REGISTER_MANAGE: 'mrd:register:manage',
    MRD_CERTIFICATE_ISSUE: 'mrd:certificate:issue',
    MRD_RETENTION_MANAGE: 'mrd:retention:manage',
};
exports.ALL_MRD_PERMISSIONS = Object.values(exports.MrdPermissions);
//# sourceMappingURL=mrd.permissions.js.map